import './App.css';
import NavBar from './components/NavBar';
import { Banner } from './components/Banner';
// 1. Importe o BrowserRouter
import { BrowserRouter as Router } from 'react-router-dom';
import { Skills } from './components/Skills';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Projects} from "./components/Projects";
import {Contact} from "./components/Contact";

function App() {
    return (
        <Router>
            <div className="App">
                <NavBar />
                <Banner />
                <Skills />
                <Projects />
                <Contact />
            </div>
        </Router>
    );
}

export default App;
